import ButtonGroup from "../../../components/ButtonGroup";
import BePartImg from "../../../assets/be-part-img.png";

export default function BePart() {
  return (
    <section id="be_part">
      <div className="container">
        <div className="row-essy">
          <div className="col-essy-lg-6 col-essy-md-6">
            <div className="be-part-text">
              <h2>Be Part of Building It</h2>
              <p>
                We’re onboarding candidates into beta and opening a limited
                waitlist for early employer access.{" "}
              </p>
              <ButtonGroup />
            </div>
          </div>
          <div className="col-essy-lg-6 col-essy-md-6">
            <div className="be-part-img">
              <img src={BePartImg} alt="shape" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
